import { all, call, takeLatest } from '@redux-saga/core/effects';
import axios from 'axios';
import { fork, put } from 'redux-saga/effects';
import {
  GET_RESERVE_HISTORY_REQUEST,
  GET_RESERVE_HISTORY_SUCCESS,
  GET_RESERVE_HISTORY_FAILURE,
  PUT_CANCEL_RESERVE_REQUEST,
  PUT_CANCEL_RESERVE_SUCCESS,
  PUT_CANCEL_RESERVE_FAILURE,
  PUT_REMOVE_WAIT_CANCEL_REQUEST,
  PUT_REMOVE_WAIT_CANCEL_SUCCESS,
  PUT_REMOVE_WAIT_CANCEL_FAILURE,
  COMMON_FAILURE,
} from '../../actions';

import { reserveHistoryService } from '../../services';

// 予約履歴取得
export type GetReserveHistoryActionType = {
  type: typeof GET_RESERVE_HISTORY_REQUEST;
  memberId: string;
  requestYearMonth: string;
  history: string[];
};

function* getReserveHistory(action: GetReserveHistoryActionType): Generator<unknown> {
  try {
    const res = yield call(reserveHistoryService(action).getReserveHistory);
    yield put({
      type: GET_RESERVE_HISTORY_SUCCESS,
      res,
    });
  } catch (error) {
    if (axios.isAxiosError(error)) {
      yield put({
        type: GET_RESERVE_HISTORY_FAILURE,
        error: error.response,
      });
      yield put({
        type: COMMON_FAILURE,
        error: error.response,
      });
    }
    action.history.push('/systemError');
  }
}

function* watchGetReserveHistory() {
  yield takeLatest(GET_RESERVE_HISTORY_REQUEST, getReserveHistory);
}

// 予約キャンセル
export type PutCancelReserveActionType = {
  type: typeof PUT_CANCEL_RESERVE_REQUEST;
  contentsId: number;
  scheduleId: number;
  history: string[];
};

function* putCancelReserve(action: PutCancelReserveActionType): Generator<unknown> {
  try {
    const res = yield call(reserveHistoryService(action).putCancelReserve);
    yield put({
      type: PUT_CANCEL_RESERVE_SUCCESS,
      res,
    });
  } catch (error) {
    if (axios.isAxiosError(error)) {
      yield put({
        type: PUT_CANCEL_RESERVE_FAILURE,
        error: error.response,
      });
      yield put({
        type: COMMON_FAILURE,
        error: error.response,
      });
      if (error.response && error.response.status >= 500) {
        action.history.push('/system-error');
      }
    }
    // action.history.push('/systemError');
  }
}

function* watchPutCancelReserve() {
  yield takeLatest(PUT_CANCEL_RESERVE_REQUEST, putCancelReserve);
}

// キャンセル待ち解除
export type PutRemoveWaitCancelActionType = {
  type: typeof PUT_REMOVE_WAIT_CANCEL_REQUEST;
  contentsTimeCancelWaitId: number;
  history: string[];
};

function* putRemoveWaitCancel(action: PutRemoveWaitCancelActionType): Generator<unknown> {
  try {
    const res = yield call(reserveHistoryService(action).putRemoveWaitCancel);
    yield put({
      type: PUT_REMOVE_WAIT_CANCEL_SUCCESS,
      res,
    });
  } catch (error) {
    if (axios.isAxiosError(error)) {
      yield put({
        type: PUT_REMOVE_WAIT_CANCEL_FAILURE,
        error: error.response,
      });
      yield put({
        type: COMMON_FAILURE,
        error: error.response,
      });
    }
    action.history.push('/systemError');
  }
}

function* watchPutRemoveWaitCancel() {
  yield takeLatest(PUT_REMOVE_WAIT_CANCEL_REQUEST, putRemoveWaitCancel);
}

export default function* reserveHistorySaga(): Generator<unknown> {
  yield all([fork(watchGetReserveHistory), fork(watchPutCancelReserve), fork(watchPutRemoveWaitCancel)]);
}
